<script>
  export default {
    props: {
      inscricao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        notas: [],
        nota: this.camposNota(),
      }
    },
    methods: {
      camposNota() {
        return {
          descricaoNota: '',
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) {
              throw new Error("validacao");
            }
            else {
              this.inscricao.inscricaoNotas.push(this.nota);
              this.nota = this.camposNota();
              this.$validator.reset();
            }
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      deletarNota(indice) {
        this.inscricao.inscricaoNotas.splice(indice, 1);
      },
    },
  }
</script>

<template>
  <div>
    <div class="ibox-footer">
      <div class="table-responsive">
        <table class="table table-bordered table-column-code table-column-action">
          <thead v-if="inscricao.inscricaoNotas.length > 0">
            <tr>
              <th></th>
              <th>Nota</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="inscricao.inscricaoNotas.length > 0">
            <tr v-for="(nota, index) in inscricao.inscricaoNotas">
              <td>N{{ index + 1 }}</td>
              <td>{{ nota.descricaoNota }}</td>
              <td>
                <div class="form-group no-margins">
                  <button type="button"
                          class="btn btn-sm btn-danger btn-delete-item"
                          title="Excluir item"
                          @click="deletarNota(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="inscricao.inscricaoNotas.length === 0">
            <tr>
              <td class="text-center">Nenhuma nota da inscrição encontrada.</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('nota')}">
          <label class="control-label" for="nota">Nota</label>

          <input type="text"
                 class="form-control"
                 id="nota"
                 v-model="nota.descricaoNota"
                 data-vv-name="nota"
                 data-vv-as="nota"
                 v-validate="'required'">
          <p class="text-danger" v-show="errors.has('nota')">{{ errors.first('nota') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar nota
          </button>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-20"></div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="observacoesNota">
            Observações das notas
          </label>

          <textarea class="form-control"
                    id="observacoesNota"
                    v-model="inscricao.observacaoNotas">
          </textarea>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-matricular/componentes/compartilhado/FormInscricaoNotas.vue